// extracted by mini-css-extract-plugin
export default {"systemic-logo":"App_systemic-logo__747RB","page":"App_page__W02Oo","desktop_only":"App_desktop_only__tW+xD"};